
// Compile our scss
// This 'includes' the SCSS index file which webpack then reads and 
// compiles into the necessary css files
require('../scss/index.scss');

require('./components/global.js');
require('./components/search.js');
require('./components/toggles-switches.js');
require('./components/accordion.js');
require('./components/navigation.js');